var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-body-wrapper"},[_vm._t("body"),_vm._t("testButton")],2)}
var staticRenderFns = []

export { render, staticRenderFns }